import * as actions from '..';

const paymentReducerDefaultState = {
  paymentMethods: [],
  vantivResponse: {},
};
const PAYMENT_STATUS = {
  ACTIVE: 0,
  INACTIVE: 1,
};

export const paymentReducer = (state = paymentReducerDefaultState, action) => {
  switch (action.type) {
    case actions.ADD_PAYMENT_METHODS:
      return {
        ...state,
        paymentMethods: [...action.payload],
      };
    case actions.ADD_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethods: [
          ...state.paymentMethods.map(paymentMethod => ({
            ...paymentMethod,
            status: 1,
          })),
          action.payload,
        ],
      };
    case actions.SET_VANTIV_RESPONSE:
      return {
        ...state,
        vantivResponse: {
          ...action.payload,
        },
      };
    case actions.SET_VANTIV_RESPONSE_EMPTY:
      return {
        ...state,
        vantivResponse: paymentReducerDefaultState.vantivResponse,
      };
    case actions.SET_DEFAULT_PAYMENT:
      return {
        ...state,
        paymentMethods: state.paymentMethods.map(paymentMethod => ({
          ...paymentMethod,
          status:
            action.payload === paymentMethod.paymentMethodUuid
              ? PAYMENT_STATUS.ACTIVE
              : PAYMENT_STATUS.INACTIVE,
        })),
      };
    default:
      return state;
  }
};
